import { createSelector } from 'reselect';
const getState = state => state.auth;
export const getUser = createSelector([getState], state => state && state.user || {});
export const getGates = createSelector([getState], state => state && state.gates || []);